var map = {
	"./benleumi.png": 65933,
	"./discount.png": 87865,
	"./doar.png": 13030,
	"./jerusalem.png": 27004,
	"./leumi.png": 82658,
	"./massad.png": 16247,
	"./mercantile.png": 84294,
	"./mizrahi.png": 5368,
	"./onezero.png": 41960,
	"./otsar.png": 65187,
	"./pagi.png": 35781,
	"./pepper.png": 93680,
	"./poalim.png": 62042,
	"./ubank.png": 32601,
	"./yahav.png": 32513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35002;